import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';
import contractFields from '../../fields/contractFields';

const mutationDeleteMultipleContracts = (onSuccess, onError) => {
    return {
        mutationFn: ({ merchantAccountId, contractsIds }) => {
            return client.delete(replaceParameters(CONTRACTS.DELETE_MULTIPLE_CONTRACTS.url, { contractAccessId: merchantAccountId }),
                { data: { [contractFields.UUIDS_CONTRACTS.key]: contractsIds } });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeleteMultipleContracts;